import AppointmentMinimalDetails from '@/pages/Profile/components/AppointmentMinimalDetails';
import { AppointmentAttendance } from '@/types/appointmentAttendance';
import { DataRow } from '@/ui/components/DataList';

interface Props {
  nextAppointmentAttendance?: AppointmentAttendance;
  memberTZ?: string | null;
}

export function NextAppointment({ nextAppointmentAttendance, memberTZ }: Props) {
  const timeZone = memberTZ || 'America/Los_Angeles';
  return (
    <DataRow
      label="Next Appointment"
      content={
        nextAppointmentAttendance ? (
          <AppointmentMinimalDetails
            appointmentAttendance={nextAppointmentAttendance}
            timeZone={timeZone}
          />
        ) : (
          <span>No Upcoming Appointments</span>
        )
      }
    />
  );
}
